import { TextField, Stack } from "@mui/material";
import { RecordingDeviceType } from "./RecordingDeviceType";
import { Controller, useFormContext } from "react-hook-form";

export const FileDetailsWavType = () => {
  const { control } = useFormContext();

  return (
    <Stack gap={3}>
      <RecordingDeviceType />
      <Controller
        name="fileType"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="File Type"
            focused={false}
            slotProps={{
              htmlInput: {
                readOnly: true,
                type: "text",
              },
            }}
          />
        )}
      />
      <Controller
        name="display"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Bit Format"
            focused={false}
            slotProps={{
              htmlInput: {
                readOnly: true,
                type: "text",
              },
            }}
          />
        )}
      />
      <Controller
        name="sampleRate"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Sample Rate (Hz)"
            focused={false}
            slotProps={{
              htmlInput: {
                readOnly: true,
                type: "text",
              },
            }}
          />
        )}
      />
      <Controller
        name="numberOfChannels"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Number of Channels"
            focused={false}
            slotProps={{
              htmlInput: {
                readOnly: true,
                type: "text",
              },
            }}
          />
        )}
      />
    </Stack>
  );
};
